import { combineReducers } from 'redux';
import login, { actions as loginActions } from '../redux/login';
import globalState, { actions as globalActions } from '../redux/globalState';
import notes, { actions as notesActions } from '../redux/notes';
import user, { actions as userActions } from '../redux/user';
import shipTo, { actions as shipToActions } from '../redux/quick-entry/shipTo';
import billTo, { actions as billToActions } from '../redux/quick-entry/billTo';
import routing, { actions as routingActions } from '../redux/routing';
import leadData, { actions as leadDataActions } from '../redux/leadtracker/leadData';
import pmData, { actions as pmDataActions } from '../redux/pm/pmData';
import scaffoldData, { actions as scaffoldActions } from '../redux/scaffold/scaffoldData';


export const reducers = combineReducers({
	login,
	globalState,
	notes,
	user,
	routing,
	shipTo,
	billTo,
	leadData,
	pmData,
	scaffoldData
});

export const actions = {
	login: loginActions,
	globalState: globalActions,
	notes: notesActions,
	user: userActions,
	routing: routingActions,
	shipTo: shipToActions,
	billTo: billToActions,
	leadData: leadDataActions,
	pm: pmDataActions,
	scaffold: scaffoldActions
};


// WEBPACK FOOTER //
// ./src/config/reduxIndex.js